<script>
  import { fade } from "svelte/transition";
  import { fecthUserTokens } from "../../api";
  import TokenCreate from "./TokenCreate.svelte";
  import TokenDelete from "./TokenDelete.svelte";
  import TokenViewer from "./TokenViewer.svelte";
  import { Loaders } from "@shopboxai/sb-portal-components";

  let _fetchUserTokens = async () => {
    let rows = [];
    let currentUser = await fecthUserTokens();

    rows = currentUser.map((token) => {
      return {
        name: token.name,
        created: token.created_at,
        expiry: "Never",
        token: token.token,
        id: token.id,
      };
    });
    return rows;
  };
  let runFetchUserTokens = _fetchUserTokens();

  const handleComplete = async () => {
    runFetchUserTokens = _fetchUserTokens();
  };
</script>

<div class="main">
  <div class="header">
    <h3>API Tokens</h3>
    <TokenCreate on:complete={handleComplete} />
  </div>

  <div class="table sb-scrollbar sb-scrollbar-horizontal">
    <table>
      {#await runFetchUserTokens}
        <Loaders items={[{ size: 20, height: "150px" }]} />
      {:then rows}
        {#if rows.length}
          <tr>
            <th>Token name</th>
            <th>Date created</th>
            <th>Expiry date</th>
            <th>API key</th>
            <th />
          </tr>
        {/if}

        <tbody>
          {#each rows as row}
            <tr in:fade>
              <td> {row.name}</td>
              <td> {row.created}</td>
              <td>{row.expiry}</td>
              <td>
                ******
                <TokenViewer data={{ token: row.token }} />
              </td>
              <td>
                <TokenDelete
                  on:complete={handleComplete}
                  data={{
                    id: row.id,
                    name: row.name,
                  }}
                />
              </td>
            </tr>
          {:else}
            <h4>No API tokens generated yet</h4>
          {/each}
        </tbody>
      {:catch}
        No tokens
      {/await}
    </table>
  </div>
</div>

<style>.header{color:var(--t-c);display:flex;justify-content:space-between}.main{border:1px solid #d0d0d2;border-radius:4px;gap:16px;margin-top:25px;padding:12px}.table{color:var(--t-c);margin-top:10px;overflow-y:scroll;width:100%}.table :global(table){border-collapse:collapse;width:100%}.table :global(:is(td,th)){font-size:14px;padding:15px 10px 0;text-align:left;white-space:nowrap}.table :global(:is(th)){color:var(--t-c-l);font-weight:400}.table :global(:is(tr)):last-child>:global(:is(td)){border-bottom:0}tr{border-bottom:1px solid #ddd}h4{color:var(--t-c-lx)}</style>
